import { render, staticRenderFns } from "./confirm-delete.vue?vue&type=template&id=90932834&scoped=true"
import script from "./confirm-delete.vue?vue&type=script&lang=js"
export * from "./confirm-delete.vue?vue&type=script&lang=js"
import style0 from "./confirm-delete.vue?vue&type=style&index=0&id=90932834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90932834",
  null
  
)

export default component.exports